import { useTranslation } from "react-i18next"

import { MessageCircleQuestion } from "@/components/icons"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"

type FollowupQuestionsProps = {
  followupQuestions: string[]
  onClick: (question: string) => void
}

export function FollowupQuestions({ followupQuestions, onClick }: FollowupQuestionsProps) {
  const { t } = useTranslation()

  return (
    <Card className="border-0 pb-2 shadow-none">
      <CardHeader className="p-0 pb-2">
        <CardTitle className="text-base font-bold">{t("answer.follow_up_questions")}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-2 p-0" data-testid="followup-questions-content">
        {followupQuestions.map((question, index) => (
          <button
            key={index}
            className="bg-sidebar text-sidebar-foreground hover:bg-accent hover:text-accent-foreground focus-visible:ring-ring flex w-full cursor-pointer items-center gap-2 rounded-md p-2 px-3 text-left focus-visible:ring-1 focus-visible:outline-none"
            type="button"
            onClick={() => onClick(question)}
          >
            <MessageCircleQuestion className="shrink-0" />
            <p key={index}>{question}</p>
          </button>
        ))}
      </CardContent>
    </Card>
  )
}
